import {
  Backdrop,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";
import Swal from "sweetalert2";

import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { common_axios } from "../../../App";
import { xCheckSumIdGernator } from "../../../helper/helper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function ChangePassword() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);
  const [verify, setVerify] = useState("");
  const [documents, setDocuments] = useState("");
  const [user, setUser] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const [showPassword1, setShowPassword1] = useState(false);
  const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1); 
   const [showPassword2, setShowPassword2] = useState(false);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);
  const handleClickShowPassword2= () => setShowPassword2(!showPassword2);
  const callbackFunction = (childData) => {
    setVerify(childData);
  };
  const callbackFunction1 = (childData) => {
    setDocuments(childData);
  };
  const callbackFunction2 = (childData) => {
    setUser(childData);
  };
  const validationSchema = yup.object({
    newPassword: yup
      .string("Enter Your NewPassword")
      .min(8)
      .max(40)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character")
        .test(
          "newPassword",
          "New password cannot be the same as old password",
          function (value) {
            const { oldPassword } = this.parent;
            return value !== oldPassword;
          }
        )
      .required("NewPassword is required"),
      oldPassword: yup
      .string("Enter Your oldPassword")
    
      .min(8)
      .max(40)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character")
        // .oneOf([!yup.ref("newPassword"), null], "Passwords doesn't match")

        .required("oldPassword is required"),

    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      oldPassword: "",
      confirmPassword:"",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      Password(values)
    },
  });
  const UserId = localStorage.getItem("UserId");
  const email = localStorage.getItem("email");
// console.log("11221",email)


  async function Password(values) {
try{
    // console.log("valueeeesssss", values);
    setOpen(true);
    const res = await common_axios
      .post(
        `${process.env.REACT_APP_COMMON_API}/auth/v2/update/new/password`,
        // "http://192.168.167.66:5001/auth/v1/update/new/password",
         {
          emailId: localStorage.getItem("email"),
          newPassword:values.newPassword,
          userId:localStorage.getItem("UserId"),
          oldPassword:values.oldPassword
    })
 

    if (res.data.statusDescription.statusCode == 200) {
      setOpen(false);
      formik.handleReset();

      // toast.success("Your Password has been changed successfully", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "success",
        //  title: "Oops...",
        text:"Your Password has been changed successfully",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } else {
      setOpen(false);
      // toast.error(res.data.statusDescription.description, {
      //   theme: "colored",
      // });

      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:res.data.statusDescription.description,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      // console.log(res.data.statusMessage);
    }
   }
   catch(error){
    // toast.error("Please Check Your Network");
    Swal.fire({
      icon: "error",
       title: "Oops...",
      text:"Please Check Your Network",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
    setOpen(false);

   }

  }
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

        <ThemeProvider theme={theme}>
          <div className="container-fluid px-0">
            {/* <div className="card-header p-3 pt-2">
              
              <div className="pt-1">
                <p
                  className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                  style={{ marginLeft: "70px" }}
                >
                </p>
              </div>
            </div> */}
            <div className="card-body p-0">
              <div className="card shadow-none border bg_blue">
                <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                  Change Password
                </span>

                <div className="card-body text-lg-start text-center">
                  <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                  <div className="col-md-4">
                      <TextField
                        required
                        className="w-100"
                        label="Old Password"
                        name="oldPassword"
                        type={showPassword ? "text" : "password"}
                        variant="outlined"
                        size="small"
                        value={formik.values.oldPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.oldPassword &&
                          Boolean(formik.errors.oldPassword)
                        }
                        helperText={
                          formik.touched.oldPassword &&
                          formik.errors.oldPassword
                        }
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <TextField
                        required
                        className="w-100"
                        label="New Password"
                        name="newPassword"
                        type={showPassword1 ? "text" : "password"}
                        variant="outlined"
                        size="small"
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.newPassword &&
                          Boolean(formik.errors.newPassword)
                        }
                        helperText={
                          formik.touched.newPassword &&
                          formik.errors.newPassword
                        }
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword1}
                                onMouseDown={handleMouseDownPassword1}
                              >
                                {showPassword1 ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                    <div className="input-group input-group-outline">

                      <TextField
                        required
                        className="w-100"
                        label="Confirm Password"
                        name="confirmPassword"
                        type={showPassword2 ? "text" : "password"}
                        variant="outlined"
                        size="small"
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.confirmPassword &&
                          Boolean(formik.errors.confirmPassword)
                        }
                        helperText={
                          formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                        }
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword2}
                              >
                                {showPassword2 ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                    </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12 d-flex justify-content-end text-end">
                      <div className="">
                        <button className="btn btn-primary m-0" type="submit">
                          Submit
                        </button>
                        </div>
                        <div className="">
                        <button
                                        onClick={formik.resetForm}
                                        type="button"
                                        className="btn bg-gradient-secondary m-0 ms-3 w-100"
                                        // onClick={Reset}
                                      >
                                        Reset
                                        <i class="material-icons opacity-10">
                                          settings_backup_restore
                                        </i>
                                      </button>
                                      </div>
                      </div>
                    </div>

                    {/* <button type="button" className="btn btn-primary">
              Save
            </button> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}


